"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BerserkingEffectHandler = exports.BerserkingEffectArgs = void 0;
const Duration_1 = require("../../Duration");
const enums_1 = require("../../enums");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
const CharmImmunity_1 = require("./CharmImmunity");
const MaxAttributeIncrease_1 = require("./MaxAttributeIncrease");
const StunImmunity_1 = require("./StunImmunity");
class BerserkingEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.Berserking;
        this.__typeName = "Berserking";
        this.name = "Berserking";
        this.harmful = true;
    }
}
exports.BerserkingEffectArgs = BerserkingEffectArgs;
// TODO: Remove!
let BerserkingEffectHandler = class BerserkingEffectHandler {
    apply(sequence, container, state) {
        state.meta.effectIds = container.applyBuffs({
            sequence,
            creatorId: state.creatorId,
            targetId: state.targetId,
            effects: [
                {
                    effect: new MaxAttributeIncrease_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Power, 5 * container.getLevel(state.creatorId)),
                    duration: Duration_1.Duration.Permanent,
                    supernatural: true,
                },
                {
                    effect: new StunImmunity_1.StunImmunityEffectArgs(),
                    duration: Duration_1.Duration.Permanent,
                    supernatural: true
                },
                {
                    effect: new CharmImmunity_1.CharmImmunityEffectArgs(),
                    duration: Duration_1.Duration.Permanent,
                    supernatural: true
                }
            ]
        });
    }
    remove(sequence, container, state) {
        sequence = sequence.pushSequence("parallel");
        state.meta.effectIds.forEach(id => container.cancelEffect(sequence, id));
    }
};
BerserkingEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Berserking)
], BerserkingEffectHandler);
exports.BerserkingEffectHandler = BerserkingEffectHandler;
